import React from 'react';
import { PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-esbelta-lavender border-t border-esbelta-violet/10 pt-16 pb-8 px-4 text-gray-700" data-id="element-65">
      <div className="max-w-6xl mx-auto" data-id="element-66">
        <div className="mb-12" data-id="element-67">
          <div className="font-serif text-3xl font-bold text-esbelta-violet tracking-tight mb-2" data-id="element-68">
            ESBELTA<sup className="text-sm" data-id="element-69">®</sup>
          </div>
          <p className="text-gray-500 text-sm" data-id="element-70">
            Tu cuerpo sabe cómo volver a ser tuyo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12" data-id="element-71">
          <div data-id="element-72">
            <h4 className="font-bold text-lg text-esbelta-violet mb-4" data-id="element-73">
              Nosotros:
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-74">
              <li data-id="element-75">
                <a href="#" className="hover:text-esbelta-violet transition-colors" data-id="element-76">
                  Inicio
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="hover:text-esbelta-violet transition-colors" data-id="element-78">
                  Catálogo
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-esbelta-violet transition-colors" data-id="element-80">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-81">
            <h4 className="font-bold text-lg text-esbelta-violet mb-4" data-id="element-82">
              Contacto:
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-83">
              <li className="text-gray-500" data-id="element-84">
                Aclaración: los pedidos pueden demorar entre 5 y 8 días hábiles.
              </li>
              <li data-id="element-85">Nuestras oficinas están en Buenos Aires, Argentina.</li>
              <li className="flex items-center gap-2" data-id="element-86">
                <PhoneIcon className="w-4 h-4 text-esbelta-violet" data-id="element-87" /> WhatsApp:
                [NÚMERO]
              </li>
              <li className="flex items-center gap-2" data-id="element-88">
                <MailIcon className="w-4 h-4 text-esbelta-violet" data-id="element-89" />{' '}
                atencion@esbeltagomitas.com.ar
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-esbelta-violet/10 pt-8 text-center text-gray-500 text-sm" data-id="element-90">
          © 2025 ESBELTA® Argentina — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}